import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/styles';
import { Typography, Link } from '@material-ui/core';

const useStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(4)
  }
}));

const Footer = props => {
  const { className, ...rest } = props;

  const classes = useStyles();

  return (
    <div
      {...rest}
      className={clsx(classes.root, className)}
    >
      <Typography variant="caption">
        Powered By
      </Typography>
      <Typography variant="body1">
        &copy;{' '}
        <Link
          color="black"
          component="a"
          href="https://softlogic.pt/"
          target="_blank"
        >
          SOFTLOGIC
        </Link>
        . {new Date().getFullYear()}
      </Typography>

    </div>
  );
};

Footer.propTypes = {
  className: PropTypes.string
};

export default Footer;
